// eslint-disable-next-line
export const CHANGE_NEWS_TAB = 'MANUAL_TRADE/CHANGE_NEWS_TAB';
